"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESOURCE_SETTINGS_PKEY = exports.DEFAULT_RECORD_INDEX = exports.DELETED_AT_FIELD_NAME = exports.VALUE_FIELD_NAME = exports.RESOURCE_NAME_TYPE_ENUM_NAME = exports.KEY_FIELD_NAME = exports.ENTITY_ID_FIELD_NAME = exports.ENTITY_TYPE_FIELD_NAME = exports.ORG_ID_FIELD_NAME = void 0;
exports.ORG_ID_FIELD_NAME = 'organizationId';
exports.ENTITY_TYPE_FIELD_NAME = 'entityType';
exports.ENTITY_ID_FIELD_NAME = 'entityId';
exports.KEY_FIELD_NAME = 'key';
exports.RESOURCE_NAME_TYPE_ENUM_NAME = 'ResourceNameTypeEnum';
exports.VALUE_FIELD_NAME = 'value';
exports.DELETED_AT_FIELD_NAME = 'deletedAt';
exports.DEFAULT_RECORD_INDEX = 0;
exports.RESOURCE_SETTINGS_PKEY = 'ResourceSettings_orgId_entityType_entityId';
//# sourceMappingURL=resource-settings.consts.js.map